module.exports = __webpack_public_path__ + "img/employeeManagement.d4e2560f.svg";